var _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse4, _path29, _rect, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 601.02,
    height: 677.11,
    viewBox: "0 0 601.02 677.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.33,446.5c-5.87-1.52-13,5.94-18.01,17.78l-.15-3.97c-19.39-8.71-38.48-15.54-57.19-20.15l-.35,2.82c-3.2-19.33-8.58-40.8-15.45-62.35,26.7-15.53,46.83-41.18,55.28-71.83,4.44-16.12,4.55-29.9-7.14-31.59-6.43-.92-15.01,6.75-22.74,15.88-12.58,14.85-29.13,25.31-47.45,29.9-5.48-12.09-11.28-23.52-17.27-33.82-3.54-6.09-6.94-12.26-10.34-18.44-35.55-64.54-135.4-36.97-112.75,57.08,12.7,36.66-8.21,73.81-20.4,109.05-18.86,10.89-35.14,21.86-48.54,32.91l-.47,2.87c-4.78-16.51-13.81-28-20.97-26.15-7.66,1.98.12,35.35.12,35.35,0,0,7.14,28.55,14.29,31.13l-.12.72c15.78-1.6,38.05-1.12,62.3,0h182.84l-.03.26c22.11-1.3,44.98-1.22,68.46,0l-.03-.86s.02,0,.03.01c7.66,1.98,15.97-31.25,15.97-31.25,0,0,7.78-33.37.12-35.35Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 267.91,
    y1: 382.98,
    x2: 367.49,
    y2: 382.98,
    fill: "none",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.98,389.11h69.45c21.28,0,38.55,17.28,38.55,38.55v88.09c0,13.53-10.98,24.51-24.51,24.51h-97.53c-13.53,0-24.51-10.98-24.51-24.51v-88.09c0-21.28,17.28-38.55,38.55-38.55Z",
    fill: "#fff",
    opacity: 0.8,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.98,389.11h69.45c21.28,0,38.55,17.28,38.55,38.55v88.09c0,13.53-10.98,24.51-24.51,24.51h-97.53c-13.53,0-24.51-10.98-24.51-24.51v-88.09c0-21.28,17.28-38.55,38.55-38.55Z",
    fill: "none",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M374.47,494.37c7.12-12.33-1.05-37.06-23.66-50.12-22.62-13.06-51.12-9.5-58.24,2.83-7.12,12.33,5.44,32.92,28.06,45.97,22.62,13.06,46.72,13.64,53.84,1.31Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.96,463.32c1.95-2.88-.25-7.78-4.91-10.95s-10.04-3.4-11.99-.52c-1.95,2.88,1.95,5.26,6.62,8.43s8.33,5.92,10.28,3.04Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.15,456.95c1.98-1.96,1.01-6.15-2.17-9.36-3.18-3.21-7.36-4.22-9.34-2.26s.72,4.44,3.9,7.65,5.63,5.94,7.61,3.98Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.45,449.22c-.56-2.63-4.46-4.02-8.72-3.12s-7.26,3.77-6.7,6.4c.56,2.63,3.97,1.73,8.23.82,4.26-.91,7.74-1.47,7.19-4.1Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M364.74,491.15c2.67.24,5.16-3.07,5.56-7.41.4-4.33-1.45-8.05-4.13-8.29-2.67-.24-2.83,3.29-3.22,7.62-.4,4.33-.89,7.83,1.79,8.08Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M341.32,439.58c.59-3.29-3.25-6.74-8.58-7.7-5.33-.96-10.14.93-10.73,4.22s3.77,3.86,9.1,4.82c5.33.96,9.62,1.95,10.21-1.34Z",
    fill: "#858585",
    strokeWidth: 0
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.17,
    cy: 460.34,
    rx: 6.38,
    ry: 2.81,
    fill: "#858585",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M332.41,474.41c-7.29-9.08-32.86-12.74-55.29-2.81-22.43,9.93-33.22,29.68-25.93,38.76,7.29,9.08,31.39,8.39,53.82-1.54,22.43-9.93,34.7-25.33,27.4-34.41Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.71,471.92c-1.56-2.31-6.91-2.66-11.95-.78-5.04,1.88-7.86,5.27-6.3,7.58s5.55.64,10.59-1.24c5.04-1.88,9.23-3.25,7.66-5.56Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.15,464.31c-.75-1.99-4.88-2.88-9.23-1.99-4.35.9-7.28,3.24-6.53,5.23s4.23,1.14,8.58.24c4.35-.9,7.93-1.5,7.18-3.49Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266.64,493.07c-2.57-.59-5.69,1.44-6.98,4.52-1.29,3.09-.25,6.07,2.32,6.65s3.45-1.95,4.73-5.04c1.29-3.09,2.49-5.55-.07-6.14Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.85,479.55c1.52-1.64-.16-4.46-3.75-6.28-3.59-1.83-7.73-1.97-9.25-.33s1.49,3.02,5.08,4.85c3.59,1.83,6.41,3.41,7.92,1.77Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M268.4,476.05c-2.58-1.58-7.47-.33-10.91,2.77-3.44,3.11-4.14,6.9-1.55,8.48,2.58,1.58,5.21-1.04,8.65-4.15,3.44-3.11,6.4-5.53,3.81-7.1Z",
    fill: "#858585",
    strokeWidth: 0
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.07,
    cy: 489.5,
    rx: 5.23,
    ry: 2.54,
    transform: "translate(-271.14 374.87) rotate(-48.34)",
    fill: "#858585",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M369.67,513.88c-3.97-9.21-27-19.06-51.43-17.25-24.43,1.82-41.02,14.61-37.05,23.82,3.97,9.21,27,15.2,51.44,13.38,24.43-1.82,41.02-10.75,37.04-19.96Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.58,502.75c-.73-2.26-5.69-3.99-11.06-3.86-5.38.13-9.14,2.06-8.41,4.33.73,2.26,5.05,2.01,10.42,1.89,5.38-.13,9.78-.09,9.05-2.35Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M339.56,496.27c-.06-1.79-3.69-3.62-8.1-4.09-4.41-.47-7.93.6-7.87,2.39.06,1.79,3.63,2.05,8.04,2.52s7.99.96,7.92-.83Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M301.41,510.88c-2.24-1.17-5.85-.4-8.06,1.71-2.21,2.11-2.19,4.76.05,5.93,2.24,1.17,3.89-.62,6.1-2.73,2.21-2.11,4.15-3.74,1.91-4.91Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M360.87,515.92c1.97-.9,1.28-3.59-1.53-6.02s-6.68-3.67-8.65-2.77.44,2.81,3.25,5.24c2.81,2.43,4.96,4.45,6.93,3.56Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M308.56,497.81c-1.94-1.96-6.96-2.29-11.22-.75s-6.14,4.37-4.21,6.33c1.94,1.96,5.27.58,9.53-.96,4.26-1.54,7.84-2.66,5.9-4.62Z",
    fill: "#858585",
    strokeWidth: 0
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.16,
    cy: 512.23,
    rx: 5.06,
    ry: 2.21,
    transform: "translate(-177.53 168.35) rotate(-23.43)",
    fill: "#858585",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M244.14,399.19c6.66,13.51,18.5,23.77,32.84,28.36,12.12,3.88,23.34,7.01,24.81,14.66,1.06,5.53-5.33,11.97-15.47,16.67-19.67,9.11-42.39,6.54-59.75-5.48",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M457.19,340.4c4.59-9.83-3.34-35.82-21.52-54.68-18.18-18.86-39.72-23.45-44.31-13.62-4.59,9.83,6.42,33.08,24.6,51.94,18.18,18.86,36.64,26.19,41.24,16.36Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M444.74,306.84c1.3-2.21-.72-7.53-4.51-11.87-3.78-4.34-7.9-6.07-9.2-3.86-1.3,2.21,1.86,5.59,5.64,9.94s6.77,8.01,8.07,5.79Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M450.56,303.03c1.38-1.32.35-5.61-2.3-9.58-2.65-3.97-5.91-6.11-7.29-4.79-1.38,1.32.86,4.46,3.5,8.43,2.65,3.97,4.71,7.27,6.09,5.95Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M412.81,281.96c-.61-2.68-3.69-5.11-6.88-5.44-3.19-.33-5.29,1.58-4.68,4.25s3.16,2.77,6.35,3.1c3.19.33,5.82.76,5.21-1.91Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M449.54,334.58c2.06.98,3.74-1.5,3.74-5.54,0-4.04-1.66-8.12-3.72-9.11s-1.93,2.36-1.94,6.4-.14,7.26,1.92,8.25Z",
    fill: "#858585",
    strokeWidth: 0
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M428.1,278.57c.23-2.99-2.95-7.37-7.09-9.79-4.14-2.42-7.68-1.96-7.91,1.03s3.14,4.76,7.29,7.18,7.49,4.57,7.71,1.58Z",
    fill: "#858585",
    strokeWidth: 0
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.53,
    cy: 295.9,
    rx: 2.39,
    ry: 5.34,
    transform: "translate(-33.25 537.47) rotate(-62.93)",
    fill: "#858585",
    strokeWidth: 0
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M449.43,310.53c-14.75-6.1-22.38-16.07-21.79-30.5.16-3.82,3.59-6.65,7.23-6.03,16.45,2.77,23.38,13.59,23.69,30.01.09,4.9-4.74,8.34-9.13,6.53Z",
    fill: "#fff",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 263.83,
    y: 362.55,
    width: 107.74,
    height: 13.28,
    rx: 6.64,
    ry: 6.64,
    fill: "#858585",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M491.23,532.09s4.3-8.17,8.59-7.66,8.26,8.17,8.26,8.17l-16.85-.51Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M83.83,525.6s4.3-5.78,8.59-5.42,8.26,5.78,8.26,5.78l-16.85-.36Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M462.13,535.53s1.67-2.06,3.35-1.93,3.22,2.06,3.22,2.06l-6.57-.13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M135.04,523.55s1.67-2.06,3.35-1.93c1.67.13,3.22,2.06,3.22,2.06l-6.57-.13Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.82,527.72s.32-.39.63-.36.61.39.61.39l-1.24-.02Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M519.1,539.72s.32-.39.63-.36.61.39.61.39l-1.24-.02Z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.e38f89ee9cf63239c7b356b6d4d5a89c.svg";
export { ForwardRef as ReactComponent };